export const CREATE_SAVED_FILING_PERIOD_REQUEST = 'CREATE_SAVED_FILING_PERIOD_REQUEST';
export const CREATE_SAVED_FILING_PERIOD_SUCCESS = 'CREATE_SAVED_FILING_PERIOD_SUCCESS';
export const CREATE_SAVED_FILING_PERIOD_FAILURE = 'CREATE_SAVED_FILING_PERIOD_FAILURE';

export const GET_SAVED_FILING_PERIOD_FILE_REQUEST = 'GET_SAVED_FILING_PERIOD_FILE_REQUEST';
export const GET_SAVED_FILING_PERIOD_FILE_SUCCESS = 'GET_SAVED_FILING_PERIOD_FILE_SUCCESS';
export const GET_SAVED_FILING_PERIOD_FILE_FAILURE = 'GET_SAVED_FILING_PERIOD_FILE_FAILURE';

export const DELETE_SAVED_FILING_PERIOD_FILE_REQUEST = 'DELETE_SAVED_FILING_PERIOD_FILE_REQUEST';
export const DELETE_SAVED_FILING_PERIOD_FILE_SUCCESS = 'DELETE_SAVED_FILING_PERIOD_FILE_SUCCESS';
export const DELETE_SAVED_FILING_PERIOD_FILE_FAILURE = 'DELETE_SAVED_FILING_PERIOD_FILE_FAILURE';

export const DELETE_SAVED_FILING_PERIOD_REQUEST = 'DELETE_SAVED_FILING_PERIOD_REQUEST';
export const DELETE_SAVED_FILING_PERIOD_SUCCESS = 'DELETE_SAVED_FILING_PERIOD_SUCCESS';
export const DELETE_SAVED_FILING_PERIOD_FAILURE = 'DELETE_SAVED_FILING_PERIOD_FAILURE';

export const LIST_SAVED_FILING_PERIOD_FILES_REQUEST = 'LIST_SAVED_FILING_PERIOD_FILES_REQUEST';
export const LIST_SAVED_FILING_PERIOD_FILES_SUCCESS = 'LIST_SAVED_FILING_PERIOD_FILES_SUCCESS';
export const LIST_SAVED_FILING_PERIOD_FILES_FAILURE = 'LIST_SAVED_FILING_PERIOD_FILES_FAILURE';

export const PROCESS_SAVED_FILING_PERIOD_REQUEST = 'PROCESS_SAVED_FILING_PERIOD_REQUEST';
export const PROCESS_SAVED_FILING_PERIOD_SUCCESS = 'PROCESS_SAVED_FILING_PERIOD_SUCCESS';
export const PROCESS_SAVED_FILING_PERIOD_FAILURE = 'PROCESS_SAVED_FILING_PERIOD_FAILURE';

export const GET_SAVED_FILING_PERIOD_BY_ID_REQUEST = 'GET_SAVED_FILING_PERIOD_BY_ID_REQUEST';
export const GET_SAVED_FILING_PERIOD_BY_ID_SUCCESS = 'GET_SAVED_FILING_PERIOD_BY_ID_SUCCESS';
export const GET_SAVED_FILING_PERIOD_BY_ID_FAILURE = 'GET_SAVED_FILING_PERIOD_BY_ID_FAILURE';

export const UPDATE_SAVED_FILING_PERIOD_BY_ID_REQUEST = 'UPDATE_SAVED_FILING_PERIOD_BY_ID_REQUEST';
export const UPDATE_SAVED_FILING_PERIOD_BY_ID_SUCCESS = 'UPDATE_SAVED_FILING_PERIOD_BY_ID_SUCCESS';
export const UPDATE_SAVED_FILING_PERIOD_BY_ID_FAILURE = 'UPDATE_SAVED_FILING_PERIOD_BY_ID_FAILURE';

export const RESET_SAVED_FILING_PERIOD = 'RESET_SAVED_FILING_PERIOD';
export const RESET_FILES = 'RESET_FILES';
export const SET_FILING_STATUS = 'SET_FILING_STATUS';

export const LIST_SAVED_FILING_PERIOD_JSON_REQUEST = 'LIST_SAVED_FILING_PERIOD_JSON_REQUEST';
export const LIST_SAVED_FILING_PERIOD_JSON_SUCCESS = 'LIST_SAVED_FILING_PERIOD_JSON_SUCCESS';
export const LIST_SAVED_FILING_PERIOD_JSON_FAILURE = 'LIST_SAVED_FILING_PERIOD_JSON_FAILURE';

export const DELETE_SAVED_FILING_PERIOD_JSON_REQUEST = 'DELETE_SAVED_FILING_PERIOD_JSON_REQUEST';
export const DELETE_SAVED_FILING_PERIOD_JSON_SUCCESS = 'DELETE_SAVED_FILING_PERIOD_JSON_SUCCESS';
export const DELETE_SAVED_FILING_PERIOD_JSON_FAILURE = 'DELETE_SAVED_FILING_PERIOD_JSON_FAILURE';

export const UPDATE_FILING_OUTCOME_REQUEST = 'UPDATE_FILING_OUTCOME_REQUEST';
export const UPDATE_PAYMENT_DETAILS_REQUEST = 'UPDATE_PAYMENT_DETAILS_REQUEST';
